import { useFormikContext } from "formik";
import React from "react";
import cx from "classnames";
import { CheckboxWrapper } from "./PrivacyCheckbox.styles";
import { PrefillCheckbox } from "../../../../components/input";

export const PrivacyCheckbox = ({ name, title = "", children, isCarLoan }) => {
  const { errors, touched } = useFormikContext();

  const hasError = touched[name] && errors[name];

  return (
    <CheckboxWrapper className={cx({ "has-error": hasError })} squareTop={!isCarLoan}>
      <PrefillCheckbox
        name={name}
        hideErrors
        title={title}
      >
        {children}
      </PrefillCheckbox>
    </CheckboxWrapper>
  );
};